import React from 'react';
import './AisleView.css';

// ── AisleView ─────────────────────────────────────────────────────────────────
// Top-level aisle list. Renders one row per aisle.
// Live aisles are tappable → navigates into the aisle (progressive disclosure).
// Coming-soon aisles are greyed out and non-interactive.
//
// Props:
//   aisles         — array of aisle objects enriched with `count`
//   onSelectAisle  — called with the aisle object when a live row is tapped

function AisleView({ aisles, onSelectAisle }) {
  return (
    <div className="aisle-view">
      {aisles.map((aisle) => (
        <div
          key={aisle.id}
          className={`aisle-header${aisle.comingSoon ? ' aisle-coming-soon' : ''}`}
          role={aisle.comingSoon ? undefined : 'button'}
          tabIndex={aisle.comingSoon ? undefined : 0}
          onClick={aisle.comingSoon ? undefined : () => onSelectAisle(aisle)}
          onKeyDown={aisle.comingSoon ? undefined : (e) => {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              onSelectAisle(aisle);
            }
          }}
          aria-label={aisle.comingSoon ? `${aisle.name} — coming soon` : `Browse ${aisle.name}`}
        >
          <span className="aisle-emoji" aria-hidden="true">{aisle.icon}</span>
          <span className="aisle-name">{aisle.name}</span>

          {aisle.comingSoon ? (
            <span className="aisle-coming-badge">Coming soon</span>
          ) : (
            <>
              <span className="aisle-count">{aisle.count} {aisle.count === 1 ? 'item' : 'items'}</span>
              <span className="aisle-chevron-right" aria-hidden="true">›</span>
            </>
          )}
        </div>
      ))}
    </div>
  );
}

export default AisleView;
